module.exports = __webpack_public_path__ + "static/media/success-check.fef96b46.png";